import { useEffect } from 'react';
import { useRouter } from 'next/router';
import NProgress from 'nprogress';

NProgress.configure({ showSpinner: false, minimum: 0.2, speed: 300 });

/**
 * Shows a thin progress bar at the top of the page during client-side navigations.
 * Drop-in replacement point: swap the NProgress calls for a custom spinner/overlay.
 */
export default function RouteChangeIndicator() {
  const router = useRouter();

  useEffect(() => {
    const handleStart = () => NProgress.start();
    const handleDone = () => NProgress.done();

    router.events.on('routeChangeStart', handleStart);
    router.events.on('routeChangeComplete', handleDone);
    router.events.on('routeChangeError', handleDone);

    return () => {
      router.events.off('routeChangeStart', handleStart);
      router.events.off('routeChangeComplete', handleDone);
      router.events.off('routeChangeError', handleDone);
    };
  }, [router]);

  return null;
}
